export default __webpack_public_path__ + "static/media/TASKcubes-logo.1302b197.jpg";